module.exports = __webpack_public_path__ + "static/media/endometriosis-concern-news.4c095be4.jpg";